import { isNativeApp } from './platform';

/**
 * Origin used when turning relative public paths (/assets/..., /Female/...) into
 * absolute URLs the backend can download.
 *
 * On Capacitor, window.location.origin is typically https://localhost — that is
 * unreachable from the API server. Prefer REACT_APP_ASSET_BASE_URL, else the
 * API origin (REACT_APP_API_URL without trailing /api).
 */
export function getPublicAssetBaseUrl() {
  const explicit = String(process.env.REACT_APP_ASSET_BASE_URL || '')
    .trim()
    .replace(/\/+$/, '');
  if (explicit) return explicit;

  const apiUrl = String(process.env.REACT_APP_API_URL || process.env.API_BASE_URL || '')
    .trim()
    .split(/\s|#/)[0]
    .replace(/\/+$/, '');

  if (isNativeApp() && apiUrl && /^https?:\/\//i.test(apiUrl)) {
    return apiUrl.replace(/\/api$/i, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin).replace(/\/+$/, '');
  }

  if (apiUrl && /^https?:\/\//i.test(apiUrl)) {
    return apiUrl.replace(/\/api$/i, '');
  }

  return '';
}

const LOCAL_WEBVIEW_HOST_RE = /^(localhost|127\.0\.0\.1|\[::1\])$/i;

/**
 * Make a public asset path absolute and rewrite Capacitor/local WebView origins
 * so the backend can fetch the file.
 */
export function toAbsolutePublicAssetUrl(u) {
  if (!u) return u;
  const s = String(u).trim();
  if (!s) return s;
  if (s.startsWith('data:') || s.startsWith('blob:')) return s;

  const base = getPublicAssetBaseUrl();

  try {
    if (/^(https?:)?\/\//i.test(s)) {
      const absolute = s.startsWith('//')
        ? `${typeof window !== 'undefined' && window.location?.protocol ? window.location.protocol : 'https:'}${s}`
        : s;
      const parsed = new URL(absolute);
      if (LOCAL_WEBVIEW_HOST_RE.test(parsed.hostname) && base && /^https?:\/\//i.test(base)) {
        const baseParsed = new URL(base);
        parsed.protocol = baseParsed.protocol;
        parsed.host = baseParsed.host;
        return parsed.toString();
      }
      return absolute;
    }
  } catch {
    /* fall through */
  }

  if (s.startsWith('/')) {
    return base ? `${base}${s}` : s;
  }

  return s;
}
